export default __webpack_public_path__ + "static/media/subscribe.647a92b7.png";